module.exports = __webpack_public_path__ + "img/bulls-logo-icon.7bd1d6f4.png";